module.exports = __webpack_public_path__ + "img/two.f1b404f7.jpg";